module.exports = __webpack_public_path__ + "static/media/marketing-sms-campagin-iphone.0a1f97f1.png";